function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState, useRef } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useSelector } from 'react-redux';
import { ProfileContext } from 'context';
import App, { IntlHelmet, LanguageProvider, OfflineOverlay } from 'modules/App';
import Account from 'modules/Account';
import Patient, { ConfirmDataSharingModal, RevokeAccessModal } from 'modules/Patient';
import Visit from 'modules/Visit';
import Notifications from 'modules/Notifications';
import MobilePage from 'components/MobilePage';
import { useAction } from 'hooks/useAction';
import MobileLoaderLayout from '../MobileLoaderLayout';
import styles from './MobilePwdLayout.pcss';
const profileContext = {
    selectors: {
        activePatient: Account.selectors.patientProfileExtended,
        prvKeyPem: Account.selectors.prvKeyPem,
        passphrase: Account.selectors.passphrase,
        phiSet: Patient.selectors.phiSet,
        phiSetDocumentId: Patient.selectors.phiSetDocumentId,
        notes: Patient.selectors.notes,
        activeVisit: ()=>null,
        visitHistoryActiveVisit: Visit.selectors.activeVisit
    },
    actions: {
        setReadings: Patient.actions.setReadings,
        storeReadingsSuccess: Patient.actions.onStoreReadingsSuccess
    }
};
const MobilePwdLayout = ({ titleMessage, descriptionMessage, headerMessage, isInitializedSelector, backToUrl, onBackToClick, withAlertBus = true, children })=>{
    useStyles(styles);
    const activeProfileType = useSelector(Account.selectors.activeProfileType);
    const activeProfile = useSelector(Account.selectors.activeProfile);
    const isClientInitialized = useSelector(App.selectors.isClientInitialized);
    const isConnectToPatientStorageInProgress = useSelector(Account.selectors.isConnectToPatientStorageInProgress);
    const isSyncInProgress = useSelector(Patient.selectors.isSyncInProgress);
    const lastReceivedNotification = useSelector(Notifications.selectors.lastReceivedNotification);
    const lastReceivedNotificationRef = useRef(lastReceivedNotification);
    const patientProfile = useSelector(Account.selectors.patientProfile);
    const keyPair = useSelector(Account.selectors.keyPair);
    const passphrase = useSelector(Account.selectors.passphrase);
    const onSyncAction = useAction(Patient.actions.sync);
    const onClearNotesBatches = useAction(Patient.actions.clearNotesBatches);
    const onCreateSignalRHub = useAction(App.actions.createSignalRHub);
    const isInitialized = useSelector(isInitializedSelector || (()=>true));
    const [isInit, setIsInit] = useState(false);
    useEffect(()=>{
        if (isInitialized) {
            setIsInit(true);
        }
    }, [
        isInitialized
    ]);
    useEffect(()=>{
        onCreateSignalRHub();
    }, []);
    const onSync = ()=>{
        if (!process.env.BROWSER) {
            return;
        }
        onSyncAction(_object_spread_props(_object_spread({}, patientProfile), {
            keyPair
        }), passphrase);
    };
    useEffect(()=>{
        if (lastReceivedNotificationRef.current !== lastReceivedNotification) {
            if (lastReceivedNotification && lastReceivedNotification.notificationTrigger === Notifications.constants.NOTIFICATIONS_TRIGGERS.NOTE_WRITTEN_BY_HCP && !isConnectToPatientStorageInProgress && !isSyncInProgress) {
                onClearNotesBatches();
                onSync();
            }
            lastReceivedNotificationRef.current = lastReceivedNotification;
        }
    }, [
        lastReceivedNotification,
        isConnectToPatientStorageInProgress,
        isSyncInProgress
    ]);
    if (!isClientInitialized || !isInit) {
        return /*#__PURE__*/ _jsx(MobileLoaderLayout, {});
    }
    return /*#__PURE__*/ _jsx(LanguageProvider, {
        children: /*#__PURE__*/ _jsx(ProfileContext.Provider, {
            value: profileContext,
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.root,
                children: [
                    /*#__PURE__*/ _jsx(IntlHelmet, {
                        titleMessage: titleMessage,
                        descriptionMessage: descriptionMessage
                    }),
                    /*#__PURE__*/ _jsx(MobilePage, {
                        to: backToUrl,
                        backToMessage: headerMessage,
                        withAlertBus: withAlertBus,
                        onClick: onBackToClick,
                        children: children
                    }),
                    /*#__PURE__*/ _jsx(ConfirmDataSharingModal, {
                        activeProfileType: activeProfileType,
                        activeProfile: activeProfile
                    }),
                    /*#__PURE__*/ _jsx(RevokeAccessModal, {}),
                    /*#__PURE__*/ _jsx(OfflineOverlay, {})
                ]
            })
        })
    });
};
export default MobilePwdLayout;
